import {
    insertDataToTicket,
    hammerEventsHandler,
    setObjectToSessionStorage,
    getObjectFromSessionStorage,
    convertStringToObject,
    updateAllSums,
    viewPromoButton,
    num2str,
    unique,
} from "./utils";

const $ = window.jQuery;
const svgPanZoom = window.svgPanZoom;
const prices = window.prices;
const uniquePrices = window.uniquePrices;
const svg = $(".js-svg");
const eventId = svg.data("id");
const unitId = svg.data("unit");
const csrfToken = $("meta[name='csrf-token']").attr("content");
const isDesktop = window.matchMedia("(min-width: 768px)");
const storageArr = [];
const mobiles = window.matchMedia("(max-width: 767px)");

let isPlaces = true;
let placesPrices = [];
let previousHtml;
let panZoom;

export const eventObject = {
    init() {
        eventObject.setUpListeners();
        eventObject.getCartCount();

        if (svg.length) {
            eventObject.addActionToPlace();
            const sectors = svg.find("g");
            $.each(sectors, (index, sector) => {
                if (Number($(sector).attr("mode")) === 1) {
                    isPlaces = false;
                }
            });
            if (isDesktop.matches) {
                eventObject.setPanZoom();
                panZoom.zoomBy(1.4);
                if (isPlaces) {
                    $(".places__prices").show();
                    $(".places__info").show();
                } else {
                    eventObject.addActionToSector();
                }
                eventObject.getPrices();
            } else if (!isPlaces) {
                eventObject.addActionToSector();
            }
        }
    },
    setPanZoom: () => {
        const svgElement = document.querySelector("#svg-wrap svg");
        if (
            !$(svgElement)
                .parents(".places")
                .is(":visible")
        ) {
            return false;
        }
        let isEnableZoom = true;

        if (isDesktop.matches) {
            isEnableZoom = false;
        }
        panZoom = svgPanZoom(svgElement, {
            zoomEnabled: true,
            mouseWheelZoomEnabled: isEnableZoom,
            dblClickZoomEnabled: false,
            customEventsHandler: hammerEventsHandler,
            fit: true
        });
        panZoom.fit();
        panZoom.center();

        $(".js-svg-plan-zoom-in").on("click", () => {
            panZoom.zoomIn();
        });

        $(".js-svg-plan-zoom-out").on("click", () => {
            panZoom.zoomOut();
        });

        $(".js-svg-plan-reset").on("click", () => {
            panZoom.resetZoom();
            panZoom.resetPan();
            panZoom.zoom(0.75);
        });

        $(window).resize(() => {
            panZoom.resize();
            panZoom.fit();
            panZoom.zoom(0.75);
            panZoom.center();
        });

        return false;
    },

    getCartCount: (event_id = 0) => {
        const cartCount = $(".js-count");
        const url = "/event/cart/get-cart";
        $.ajax({
            url,
            data: {"_csrf-frontend": csrfToken, event_id},
            type: "POST",
            success: response => {
                const res = JSON.parse(response);
                if (res.length) {
                    cartCount.text(res.length).show();
                } else {
                    cartCount.hide();
                }
                let count = 0;

                $.each(res, (index, order) => {
                    const countTickets = order.count_tickets;
                    count += countTickets;
                });
                if (event_id && res.length) {
                    const commission = $(".js-commission");
                    if (res[0].commission) {
                        $(".places__commission").show();
                        commission.text(res[0].commission);
                    }
                }
                $(".js-count").text(count);
            },
            error: error => {
                console.error("Error ", error);
            },
        });
    },

    setActiveTickets: () => {
        const ticketsItems = $(".tickets__item");
        $.each(ticketsItems, (index, element) => {
            const place = $(element).data("place");
            const isPack = $(element).data("ispack");
            if (place && !isPack) {
                $(`#${place}`).addClass("yellow active");
                $(`#${place}`).data("available", "false");
            }
            if (isPack) {
                $(`#${place}`).data("ispack", "true");
            }
        });
    },

    setUpListeners: () => {
        $(document).on("click", ".js-promo .promo__button", e => {
            const element = $(e.target);
            const currentEventId = element.parents(".js-promo").data("event");
            const code = element
                .parents(".js-promo")
                .find(".promo__input")
                .val();
            eventObject.setPromocode(currentEventId, code);
        });

        $(document).on("keydown", ".js-promo .promo__input", e => {
            const element = $(e.target);
            const currentEventId = element.parents(".js-promo").data("event");
            const code = element.val();
            if (e.which === 13 || e.keyCode === 13 || e.key === "Enter") {
                eventObject.setPromocode(currentEventId, code);
            }
        });

        $(document).on("click", ".js-places-open", e => {
            const element = $(e.currentTarget);
            const tickets = element.parents(".places").find(".js-tickets");
            const promo = element.parents(".places").find(".js-promo");
            $(promo).show();
            element.toggleClass("active");
            $(tickets).slideToggle("slow");
        });

        $(document).on("click", ".js-tickets-remove", e => {
            const element = e.currentTarget;
            const sid = $(element)
                .parents(".tickets__item")
                .data("place");
            const elementEventId = $(element)
                .parents(".tickets__item")
                .data("event");
            eventObject.removeFromCart(sid, elementEventId);
            $(`#${sid}`).data("available", "true");
        });

        $(".js-mobile-buy").on("click", e => {
            if (!isDesktop.matches) {
                e.preventDefault();
                eventObject.getPopup();
            }
        });

        if (window.location.pathname.includes("event") && !isDesktop.matches) {
            eventObject.getPopup();
        }

        $(".js-places-button").on("click", e => {
            const element = $(e.currentTarget);
            $(".js-places-button").removeClass("active");
            element.addClass("active");
        });

        $(document).on("click", "#js-event-date", e => {
            const button = $(e.currentTarget);
            button.toggleClass("active");
            $("#js-event-dropdown").toggleClass("active");
        });

        $(document).on("click", ".places__close", () => {
            window.location.assign("/");
        });

        $(document).on("click", ".js-places-back", e => {
            const element = $(e.currentTarget);
            element.hide();
            isPlaces = false;
            $(".js-change-svg").html(previousHtml);
            eventObject.setTagsToSectors();
            eventObject.getPrices();
            $(".js-places-prices").hide();
            panZoom.destroy();
            setTimeout(eventObject.setPanZoom, 200);
            setTimeout(()=>panZoom.zoomBy(1.4), 200);
            $(".places__legend").show();
            $(".places__about").show();
            $(".places__info").hide();
            $(".places__reset").hide();
            isPlaces = false;
        });
    },

    setTagsToSectors: pricesCurrent => {
        placesPrices = [];
        $.each(pricesCurrent, (index, element) => {
            const id = element.id;
            const name = element.name;
            const price = element.price;
            const color = element.color;
            const zone = element.z;
            const selector = $(`#${id}`);
            selector.data("available", "true");
            selector.data("name", name);
            selector.data("zone", zone);
            selector.data("price", price);
            placesPrices.push(`price:${price};color:${color};zone:${zone}`);
            selector.find("rect").css("fill", color);
            selector.find("ellipse").css("fill", color);
            selector.find("circle").css("fill", color);
            selector.addClass("active");
        });
        const elements = $(".js-svg g[mode]");

        $.each(elements, (index, element) => {
            if (!$(element).hasClass("active")) {
                if (Number($(element).attr("mode")) !== 1) {
                    $(element).addClass("disabled");
                }
                if (Number($(element).attr("mode")) === 2) {
                    if (!isPlaces) {
                        $(element).addClass("active");
                    }
                }
            }
        });
    },

    setPromocode: (idEvent, code) => {
        $.ajax({
            url: "/promoevent/event-code",
            data: {event_id: idEvent, code},
            type: "POST",
            beforeSend: () => {
                $("#js-overlay").show();
            },
            success: response => {
                const res = JSON.parse(response);
                const parent = $(`.js-promo[data-event=${idEvent}]`).closest(".js-order");
                if (res.result) {
                    parent
                        .find(".js-promo")
                        .find(".promo__button")
                        .addClass("success")
                        .text("Успешно");
                    parent.find(".promo__discount").addClass("active");
                    parent.find(".promo__wrapper").css("pointer-events", "none");
                    let sale = 0;
                    let amount = 0;
                    if (parent.find(".js-promo").data("promocode")) {
                        amount = Number(parent.find(".js-summ").text());
                        sale = Number(parent.find(".js-promo-discount").text());
                    } else {
                        parent.find(".js-promo").data("promocode", code);
                    }
                    for (let i = 0; i < res.result.length; i++) {
                        sale += res.result[i].old_price - res.result[i].price;
                        const ticket = $(`.tickets__item[data-uid="${res.result[i].uid}"]`);
                        ticket.find(".js-ticket-price").text(res.result[i].price);
                        amount += res.result[i].price;
                    }

                    parent.find(".js-summ").html(amount);
                    parent.find(".js-promo-discount").html(sale);
                    parent.find(".promo__button").attr("disabled", "true");
                    parent
                        .find(".js-promo")
                        .find(".promo__message")
                        .hide();
                    parent
                        .find(".promo__input")
                        .val(code)
                        .attr("disabled", true);
                }
                if (res.error) {
                    const message = res.msg;
                    parent
                        .find(".js-promo")
                        .find(".promo__message")
                        .addClass("error")
                        .text(message);
                }
            },
            complete: () => {
                $("#js-overlay").hide();
            },
            error: error => {
                console.error("Error ", error);
            },
        });
    },
    setPlacesPrices: () => {
        $(".js-places-prices").html("");

        placesPrices = Array.from(new Set(placesPrices));
        placesPrices = placesPrices.map(item => {
            return convertStringToObject(item);
        });

        placesPrices = placesPrices.sort((a, b) => {
            return a.price - b.price;
        });

        for (let i = 0; i < placesPrices.length; i++) {
            const item = placesPrices[i];
            const placesPrice = `<label   class="places__price">
<input class="places__input" type="checkbox" data-color="${item.color}" data-zone="${item.zone}">
<span class="places__price-content"><span class="places__price-color" style="background-color: ${item.color} "></span>
<span>${item.price} ₽</span></span>
</label>`;
            $(".js-places-prices").append(placesPrice);
        }

        eventObject.addActionToPrice();
    },
    getPrices: (view_id = 0) => {
        $.ajax({
            url: "/event/get-prices",
            data: {event_id: eventId, view_id, "_csrf-frontend": csrfToken},
            type: "POST",
            beforeSend: () => {
                $("#js-overlay").show();
            },
            success: response => {
                const res = JSON.parse(response);
                if (isPlaces) {
                    eventObject.setTagsToSectors(res.prices);
                    eventObject.setPlacesPrices();
                    eventObject.addActionToPrice();
                } else {
                    eventObject.addPricesPlacesToSector();
                    eventObject.addActionToPriceSector();

                    for (let i = 0; i < res.prices.length; i++) {
                        const elem = res.prices[i];
                        const id = elem.id;
                        const color = elem.color;
                        const zone = elem.z;
                        const elemDom = $(`#${id}`);
                        elemDom.addClass("active");
                        elemDom.find("rect").css("fill", color);
                        elemDom.find("ellipse").css("fill", color);
                        elemDom.find("circle").css("fill", color);
                        elemDom.data("ispack", "true");
                        elemDom.data("zone", zone);
                    }
                }

                eventObject.setActiveTickets();
            },
            error: error => {
                console.error("Error ", error);
            },
            complete: () => {
                $(".js-places-change").addClass("active");
                $("#js-overlay").hide();
            },
        });
    },

    getSectorSvg: viewId => {
        $.ajax({
            url: "/event/get-svg",
            data: {event_id: eventId, view_id: viewId, "_csrf-frontend": csrfToken},
            type: "POST",
            beforeSend: () => {
                $("#js-overlay").show();
            },
            success: response => {
                const res = JSON.parse(response);
                $(".js-change-svg").html(res.svg);
                eventObject.getPrices(viewId);
                setTimeout(eventObject.setPanZoom, 200);
                $(".places__prices").show();
                localStorage.setItem(`${unitId}_${viewId}`, res.svg);
            },
            complete: () => {
                $("#js-overlay").hide();
            },
            error: error => {
                console.error("Error ", error);
            },
        });
    },

    getFastRegistration: () => {
        $("#fastRegisterModal")
            .detach()
            .appendTo("body");
        $("#fastRegisterModal").modal();
    },

    getPopup: () => {
        const content = $(".places__content")[0].outerHTML;
        $("#js-popup-modal .modal-body").html(`<div class="places">${content}</div>`);
        $("#js-popup-modal .places").show();
        $(".places__top").show();
        if (isPlaces) {
            $(".places__prices").show();
        }
        $(".modal-body .places__cart").prepend($(".modal-body .places__info"));
        $(".modal-body .places__cart").prepend($(".modal-body .places__prices"));
        $(".modal-body .places__name").after($(".events__mobile-info"));
        $(".modal-body .places__prices").after($(".modal-body .places__limit"));
        $(".modal-body .places__cart").prepend($(".modal-body .places__legend"));
        $(".modal-body .places__cart").append($(".modal-body .js-event-places-right"));
        $(".modal-body .places__name").after($("#js-event-date"));
        $(".modal-body .js-event-places-right").removeClass("hide");
        $(".js-tickets").hide();
        $("#js-popup-modal").modal();
        viewPromoButton();
        setTimeout(eventObject.setPanZoom, 200);
        setTimeout(eventObject.getPrices, 200);
        setTimeout(eventObject.setActiveTickets, 200);
    },

    addToCart: sid => {
        $.ajax({
            url: "/event/cart/add",
            data: {event_id: eventId, sid, "_csrf-frontend": csrfToken},
            type: "POST",
            beforeSend: () => {
                $("#js-overlay").show();
            },
            success: response => {
                const res = JSON.parse(response);
                if (res.carts) {
                    let parentElement;

                    for (let i = 0; i < res.carts.length; i++) {
                        const item = res.carts[i];
                        const isPack = res.carts[i].is_pack;
                        if (!isPack) {
                            $(`#${item.sid}`).addClass("yellow");
                        } else {
                            $(`#${item.sid}`).data("ispack", true);
                        }
                        const ticket = insertDataToTicket(item, isPack);
                        if (!$(".js-promo").data("promocode")) {
                            updateAllSums(item);
                        }
                        $(".tickets_event .js-tickets-items").append(ticket);
                        parentElement = $(`.js-order[data-event="${res.carts[i].event_id}"]`);
                    }

                    $(".js-event-places-right").show();
                    $(".js-promo").show();
                    $(".places__limit").show();

                    $(".places__change").addClass("short");
                    $(".order").removeClass("short");
                    $(".js-places-selected").text(res.order.count_tickets);
                    $(".places__cost").addClass("show");
                    $(".places__description").show();
                    $(".places-description-ticket").text(
                        num2str(res.order.count_tickets, ["билет", "билета", "билетов"]),
                    );
                    const code = parentElement.find(".js-promo").data("promocode");
                    const currentEventId = parentElement.find(".js-promo").data("event");

                    if (code) {
                        eventObject.setPromocode(currentEventId, code);
                    }

                    const buy = $(".order__button");
                    if (!buy.data("payment")) {
                        buy.data("payment", res.order.id);
                        let type = "service";
                        if (res.order.type_id === 0) {
                            type = "event";
                        }
                        buy.attr("href", `/pay/pay?id=${res.order.id}`);
                        buy.data("type", type);
                    }
                    const zone = $(`#${sid}`).data("zone");
                    const storageObject = {sid, zone};
                    const getStorage = getObjectFromSessionStorage(eventId);
                    if (getStorage) {
                        getStorage.push(storageObject);
                        setObjectToSessionStorage(eventId, getStorage);
                    } else {
                        storageArr.push(storageObject);
                        setObjectToSessionStorage(eventId, storageArr);
                    }
                }

                if (res.redraw) {
                    $(`#${sid}`).addClass("yellow");
                    window.location.reload();
                }

                if (res.limit) {
                    alert("Вы превысили максимально допустимое количество мест для брони");
                } else {
                    for (let i = 0; i < res.carts.length; i++) {
                        const item = res.carts[i];
                        const isPack = res.carts[i].is_pack;
                        if (!isPack) {
                            $(`#${item.sid}`).addClass("yellow");
                        }
                    }
                    eventObject.getCartCount(eventId);
                }
            },
            complete: () => {
                if (!$(".js-promo").data("promocode")) {
                    $("#js-overlay").hide();
                }
            },
            error: error => {
                console.error("Error ", error);
            },
        });
    },

    removeFromCart: (sid, event_id = eventId) => {
        $.ajax({
            url: "/event/cart/remove",
            data: {event_id, sid, "_csrf-frontend": csrfToken},
            type: "DELETE",
            beforeSend: () => {
                $("#js-overlay").show();
            },
            success: response => {
                const res = JSON.parse(response);
                if (response.error) {
                    window.location.reload();
                }
                if (res.redraw) {
                    alert("Данное место больше недоступно. Выберите другое. ");
                }
                const carts = res.carts;

                if (carts.length > 1) {
                    for (let i = 0; i < carts.length; i++) {
                        const currentSid = carts[i].sid;
                        $(`#${currentSid}`).removeClass("yellow");

                        $(`.tickets__item[data-place='${currentSid}']`).remove();
                    }
                } else {
                    const uid = carts[0].uid;
                    $(`.tickets__item[data-uid='${uid}']`).remove();
                    $(`#${sid}`).removeClass("yellow");
                }

                $.each($(".js-summ"), (index, el) => {
                    $(el).text(res.summ);
                });

                $(".js-places-selected").text(res.count);
                eventObject.getCartCount(eventId);
                $(".promo__discount").removeClass("active");

                if ($(".lk").length && res.count === 0) {
                    window.location.reload();
                }
                if (!$(".js-tickets-items").children().length > 0) {
                    $(".js-event-places-right").hide();
                    $(".places__cost")
                        .addClass("hide")
                        .removeClass("show");
                    $(".modal-body .js-promo").hide();
                    $(".places__common")
                        .removeClass("active")
                        .addClass("short");
                    $(".places__svg")
                        .removeClass("short")
                        .addClass("long");
                }
                $(".js-places-selected").text(res.count);
                $(".places-description-ticket").text(
                    num2str(res.count, ["билет", "билета", "билетов"]),
                );
                const getStorage = getObjectFromSessionStorage(event_id);
                for (let i = 0; i < getStorage.length; i++) {
                    if (getStorage[i].sid === sid) {
                        const zone = getStorage[i].zone;
                        const color = $(`.places__input[data-zone="${zone}"]`).data("color");
                        $(`#${sid}`).removeClass("disabled");
                        $(`#${sid}`)
                            .find("rect")
                            .css("fill", color);
                        $(`#${sid}`)
                            .find("ellipse")
                            .css("fill", color);
                        $(`#${sid}`)
                            .find("circle")
                            .css("fill", color);
                        getStorage.splice(i, 1);
                    }
                }
                setObjectToSessionStorage(event_id, getStorage);
            },
            complete: () => {
                $("#js-overlay").hide();
            },
            error: error => {
                console.error("Error ", error);
            },
        });
    },

    addActionToPlace: () => {
        $(document).on("click", e => {
            const element = e.target;
            if ($(element).closest("g.active").length) {
                const activeSector = $(element).closest("g.active");

                const sid = $(activeSector).attr("id");
                const isPack = $(activeSector).data("ispack");
                if (isPack) {
                    $(activeSector).data("available", "true");
                }
                const isCart = $(activeSector).data("available");
                if (isCart === "true") {
                    if (!isPack) {
                        $(activeSector).data("available", "false");
                    }
                    eventObject.addToCart(sid);
                } else if (isCart === "false") {
                    $(activeSector).data("available", "true");
                    eventObject.removeFromCart(sid);
                }
            }
        });
        if (isDesktop.matches) {
            $(document).on("mouseover", e => {
                const element = $(e.target);
                if (element.closest("g.active").length) {
                    const activeSector = $(element).closest("g.active");
                    const name = activeSector.data("name");
                    const price = activeSector.data("price");
                    eventObject.addTooltipToPlace(activeSector, price, name);
                } else {
                    $(".tooltip-info").hide();
                    $(".tooltip-info").css({left: 0, top: 0});
                }
                if (element.closest("g[sector_id]").length) {
                    const activeSector = $(element).closest("g[sector_id]");
                    const name = activeSector.attr("sector_name");
                    const price = activeSector.attr("price");
                    const count = activeSector.attr("all");
                    const free = activeSector.attr("free");
                    eventObject.addTooltipToSector(activeSector, price, count, free, name);
                }
            });
        }
    },

    addActionToPrice: () => {
        $(".places__price input").change(e => {
            const input = $(e.currentTarget);
            if (input.is(":checked")) {
                const color = input.data("color");
                input.next().css("border-color", color);
            }
            if ($(".places__price input:checked").length === 0) {
                $("g.active").removeClass("gray");
            } else {
                $("g.active").each((i, elem) => {
                    const el = $(elem);
                    const myPriceStr = String(el.data("zone"));
                    if (myPriceStr) {
                        const myPrice = myPriceStr.split(",");
                        let hideFlag = 0;

                        for (let j = 0; j < myPrice.length; j++) {
                            if (!$(`input[data-zone="${parseInt(myPrice[j])}"]`).is(":checked")) {
                                hideFlag++;
                            }
                        }
                        if (hideFlag === myPrice.length) {
                            el.addClass("gray");
                        } else {
                            el.removeClass("gray");
                        }
                    }
                });
            }
        });
        $(".places__price").hover(
            e => {
                const color = $(e.currentTarget)
                    .find(".places__price-color")
                    .css("background-color");
                $(e.currentTarget)
                    .find(".places__price-content")
                    .css("border-color", color);
            },
            e => {
                const input = $(e.currentTarget).find("input");
                if (input.is(":checked")) {
                    $(e.currentTarget)
                        .find(".places__price-content")
                        .css("border-color", input.data("color"));
                } else {
                    $(e.currentTarget)
                        .find(".places__price-content")
                        .removeAttr("style");
                }
            },
        );

        $(".places__price").on("click", e => {
            const element = $(e.currentTarget);
            if (element.find(".places__price-content").css("border-color") !== "transparent") {
                element.find(".places__price-content").css("border-color", "transparent");
            }
        });
    },

    addActionToPriceSector: () => {
        function addAction(input) {
            if (input.is(":checked")) {
                input
                    .parents(".places__price")
                    .find(".places__price-content")
                    .css("border-color", "#CC2128");
            } else {
                input
                    .parents(".places__price")
                    .find(".places__price-content")
                    .removeAttr("style");
            }
            if ($(".places__price input:checked").length === 0) {
                $("g[view_id]").removeClass("inactive");
            } else {
                $("g[view_id]").each((i, elem) => {
                    const el = $(elem);
                    const myPriceStr = String(el.attr("price"));
                    if (myPriceStr) {
                        const myPrice = myPriceStr.split(",");
                        let hideFlag = 0;

                        for (let j = 0; j < myPrice.length; j++) {
                            if (!$(`input[data-price="${parseInt(myPrice[j])}"]`).is(":checked")) {
                                hideFlag++;
                            }
                        }
                        if (hideFlag === myPrice.length) {
                            el.addClass("inactive");
                        } else {
                            el.removeClass("inactive");
                        }
                    }
                });
            }
            if ($(".places__price input:checked").length > 1) {
                $("#js-places-reset").show(200);
            } else {
                $("#js-places-reset").hide(200);
            }
        }

        $(".places__price input").change(e => {
            const input = $(e.currentTarget);
            addAction(input);
        });

        $(".places__price input").keypress(e => {
            if (e.which === 13) {
                const input = $(e.currentTarget);
                input[0].checked = !input[0].checked;
                addAction(input);
            }
        });

        $("#js-places-reset").on("click", () => {
            $(".places__price input").removeClass("active");
            $("g[view_id]").removeClass("hide_sector");
            $("#js-places-reset").hide(200);
            $(".places__price input").each((i, item) => {
                item.checked = false;
            });
            $(".places__price-content").removeAttr("style");
        });
    },
    addPricesToSector: () => {
        for (let i = 0; i < prices.length; i++) {
            const item = prices[i];
            const viewId = item.viewId;
            const price = item.price;
            const element = $(`g[view_id='${viewId}'`);
            if (!element.attr("price")) {
                element.attr("price", price);
            } else {
                let strPrice = element.attr("price");
                strPrice += `,${price}`;
                element.attr("price", strPrice);
            }
        }
    },

    addPricesPlacesToSector: () => {
        let elements;

        if (mobiles.matches) {
            elements = $(".modal .js-change-svg g[free]");
        } else {
            elements = $(".js-change-svg g[free]");
        }

        for (const prop in uniquePrices) {
            if (Object.prototype.hasOwnProperty.call(uniquePrices, prop)) {
                if (uniquePrices[prop] !== null) {
                    const price = uniquePrices[prop];
                    let summFree = 0;
                    let names = "";
                    for (let i = 0; i < elements.length; i++) {
                        const element = $(elements[i]);
                        if (element.attr("price")) {
                            const pricesAttr = element.attr("price").split(",");
                            for (let j = 0; j < pricesAttr.length; j++) {
                                if (price == pricesAttr[j]) {
                                    const free = element.attr("free");
                                    const name = element.attr("sector_name");
                                    names += `${name}, `;
                                    summFree += Number(free);
                                }
                            }
                        }
                    }
                    names = names.substring(0, names.length - 1);
                    names = names.substring(0, names.length - 1);
                    if (summFree) {
                        placesPrices.push(`price:${price};free:${summFree};names:${names}`);
                    }
                }
            }
        }

        $(".js-places-prices").html("");
        placesPrices = unique(placesPrices);

        placesPrices = placesPrices.map(item => {
            return convertStringToObject(item);
        });

        placesPrices = placesPrices.sort((a, b) => {
            return a.price - b.price;
        });

        for (let i = 0; i < placesPrices.length; i++) {
            const item = placesPrices[i];
            let names = item.names.split(",");
            names = unique(names);
            const placesPrice = `<label class="places__price">
<input class="places__input" type="checkbox" data-price="${item.price}">
<span class="places__custom"></span>
<span class="places__price-content places__price-content_column">
<span>Сектора ${names}</span>
<strong>${item.price} ₽, осталось ${item.free} ${num2str(item.free, [
                "место",
                "места",
                "мест",
            ])}</strong></span>
</label>`;
            $(".js-places-prices").append(placesPrice);
        }
        $(".js-places-prices").addClass("places__prices_sector");
        $(".js-places-prices").show();
    },

    addActionToSector: () => {
        $(".js-places-change").addClass("active");
        previousHtml = $(".js-change-svg").html();
        $(document).on("click", e => {
            const element = e.target;
            if ($(element).closest("g[view_id]").length) {
                const activeSector = $(element).closest("g[view_id]");
                const sectorId = activeSector.attr("sector_id") || activeSector.attr("view_id");
                const svgLocal = localStorage.getItem(`${unitId}_${sectorId}`);
                $(".places__legend").hide();
                $(".places__about").hide();
                isPlaces = true;
                if (!svgLocal) {
                    eventObject.getSectorSvg(sectorId);
                } else {
                    $(".js-change-svg").html(svgLocal);
                    setTimeout(eventObject.setPanZoom, 200);
                    eventObject.getPrices(sectorId);
                    $(".places__prices").show();
                    $(".places__info").show();
                }
                $(".places__info").show();

                panZoom.destroy();
                setTimeout(eventObject.setPanZoom, 200);
                $(".js-places-back").show();
            }
        });
    },

    addTooltipToPlace: (activeSector, price, name) => {
        const info = $(".js-seat-info");
        const clientX =
            activeSector[0].getBoundingClientRect().x ||
            activeSector[0].getBoundingClientRect().left;
        const clientY =
            activeSector[0].getBoundingClientRect().y ||
            activeSector[0].getBoundingClientRect().top;
        const y = clientY - info.outerHeight();
        const x = clientX - info.outerWidth() / 2;
        if (price) {
            info.find(".tooltip-info__price").text(`${price} ₽`);
            info.find(".tooltip-info__name").text(name);
            info.css({left: x, top: y});
            info.show();
        }
    },
    addTooltipToSector: (activeSector, price, count, free, name) => {
        const info = $(".js-sector-info");
        const clientX =
            activeSector[0].getBoundingClientRect().x ||
            activeSector[0].getBoundingClientRect().left;
        const clientY =
            activeSector[0].getBoundingClientRect().y ||
            activeSector[0].getBoundingClientRect().top;
        const y = clientY - info.outerHeight();
        const x = clientX - info.outerWidth() / 2;

        if (price.length > 1) {
            price = price.split(",");
            price = price.sort((a, b) => {
                return a - b;
            });
        }

        price = Array.from(price).map(item => {
            return ` ${item} ₽`;
        });

        info.find(".tooltip-info__price").text(`Цена ${price}`);
        info.find(".tooltip-info__name").text(`Сектор ${name}`);
        info.find(".tooltip-info__available").text(`Свободно ${free}`);
        info.find(".tooltip-info__count").text(`из ${count}`);
        info.css({left: x, top: y});
        info.show();
    },
};
